<template>
	<!-- No Transition with Tailwind by default. See benface/tailwindcss-Transitions, to add the Transition "opacity 320ms ease" -->
	<Transition
		:enter-class="variantCls.enter"
		:enter-active-class="variantCls.enterActive"
		:leave-active-class="variantCls.leaveActive"
		:leave-to-class="variantCls.leaveTo"
	>
		<div :class="variantCls.overlay" @click.self="$emit('close')">
			<div v-scroll-lock="true" :class="variantCls.root">
				<slot></slot>
			</div>
		</div>
	</Transition>
</template>

<script>
export default {
	props: {
		variant: {
			type: String,
			default: "default"
		}
	},
	computed: {
		variantCls() {
			return this.$store.getters.variants("JModalSimple", this.variant).el
		}
	}
}
</script>
